// node_modules
import { ChangeEvent, FC, RefObject } from "react";
// Components
import { FindestRefTextBox } from "Components";
// Enums
import { PartnerTimeRangeEnum } from "Enums";
// styles
import styles from "./findOrganizationsQueryFields.module.scss";

type TFindOrganizationsQueryFieldsProps = {
    customStartYearBoxRef: RefObject<HTMLInputElement>,
    customEndYearBoxRef: RefObject<HTMLInputElement>,
    timeRange: PartnerTimeRangeEnum,
    handleTimeRangeChange: (timeRange: PartnerTimeRangeEnum) => void,
    doFindUniversities: boolean,
    handleDoFindestUniversitiesChange: (doFindUniversities: boolean) => void,
    doFindResearchInstitutes: boolean,
    handleDoFindResearchInstitutesChange: (doFindResearchInstitutes: boolean) => void,
    doFindCompanies: boolean,
    handleDoFindestCompaniesChange: (doFindCompanies: boolean) => void
};

export const FindOrganizationsQueryFields: FC<TFindOrganizationsQueryFieldsProps> = ({ 
    customStartYearBoxRef,
    customEndYearBoxRef,
    timeRange,
    handleTimeRangeChange,
    doFindUniversities,
    handleDoFindestUniversitiesChange,
    doFindResearchInstitutes,
    handleDoFindResearchInstitutesChange,
    doFindCompanies,
    handleDoFindestCompaniesChange
}: TFindOrganizationsQueryFieldsProps) => {
    return (
        <div>
            <div className={styles.userFlowDataList} style={{marginBottom: "2rem"}}>
                <h5 className={styles.dataListTitle}>Organization</h5>
                <div className={styles.dataListItem}>
                    <label>
                        <input type="checkbox" checked={doFindUniversities} onChange={(event: ChangeEvent<HTMLInputElement>) => { handleDoFindestUniversitiesChange(event.target.checked); }} />
                        University
                    </label>
                </div>
                <div className={styles.dataListItem}>
                    <label>
                        <input type="checkbox" checked={doFindResearchInstitutes} onChange={(event: ChangeEvent<HTMLInputElement>) => { handleDoFindResearchInstitutesChange(event.target.checked); }} />
                        Research Institute
                    </label>
                </div>
                <div className={styles.dataListItem}>
                    <label>
                        <input type="checkbox" checked={doFindCompanies} onChange={(event: ChangeEvent<HTMLInputElement>) => { handleDoFindestCompaniesChange(event.target.checked); }} />
                        Company
                    </label>
                </div>
            </div>
            <div className={styles.userFlowDataList}>
                <h5 className={styles.dataListTitle}>Time</h5>
                <div className={styles.dataListItem}>
                    <label>
                        <input type="radio" name="wiwoi_timing" checked={timeRange === PartnerTimeRangeEnum.LastYear} onChange={() => handleTimeRangeChange(PartnerTimeRangeEnum.LastYear)} />
                        Last year
                    </label>
                </div>
                <div className={styles.dataListItem}>
                    <label>
                        <input type="radio" name="wiwoi_timing" checked={timeRange === PartnerTimeRangeEnum.Last5Years} onChange={() => handleTimeRangeChange(PartnerTimeRangeEnum.Last5Years)} />
                        Last 5 years
                    </label>
                </div>
                <div className={styles.dataListItem}>
                    <label>
                        <input type="radio" name="wiwoi_timing" checked={timeRange === PartnerTimeRangeEnum.Last10Years} onChange={() => handleTimeRangeChange(PartnerTimeRangeEnum.Last10Years)} />
                        Last 10 years
                    </label>
                </div>
                <div className={styles.dataListItem}>
                    <label>
                        <input type="radio" name="wiwoi_timing" checked={timeRange === PartnerTimeRangeEnum.All} onChange={() => handleTimeRangeChange(PartnerTimeRangeEnum.All)} />
                        All time
                    </label>
                </div>
                <div className={[styles.dataListItem, styles.dubbleSize].join(" ")}>
                    <label>
                        <input type="radio" name="wiwoi_timing" checked={timeRange === PartnerTimeRangeEnum.Custom} onChange={() => handleTimeRangeChange(PartnerTimeRangeEnum.Custom)} />
                        Custom range
                    </label>

                    {timeRange === PartnerTimeRangeEnum.Custom ?
                        <div className={styles.rangeContainer}>
                            <FindestRefTextBox ref={customStartYearBoxRef} placeholder="Start year" />
                            <span>-</span>
                            <FindestRefTextBox ref={customEndYearBoxRef} placeholder="End year" />
                        </div>
                        : <></>
                    }
                </div>
            </div>
        </div>
    );
}